import StorySummary from './StorySummary';
import './story-summary.scss';

export default StorySummary;
